import React from 'react'

const MilvusIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#00A1EA"/>
    <path d="M12 4L19 8V16L12 20L5 16V8L12 4Z" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.4" strokeWidth="0.5"/>
    <circle cx="12" cy="12" r="3.5" fill="white"/>
    <circle cx="12" cy="5.5" r="1.5" fill="white" fillOpacity="0.85"/>
    <circle cx="12" cy="18.5" r="1.5" fill="white" fillOpacity="0.85"/>
    <circle cx="5.5" cy="8.75" r="1.5" fill="white" fillOpacity="0.85"/>
    <circle cx="18.5" cy="8.75" r="1.5" fill="white" fillOpacity="0.85"/>
    <circle cx="5.5" cy="15.25" r="1.5" fill="white" fillOpacity="0.85"/>
    <circle cx="18.5" cy="15.25" r="1.5" fill="white" fillOpacity="0.85"/>
  </svg>
)

export default MilvusIcon
